import React from "react";
import { Col, Row } from "react-bootstrap";
import Switch from "react-switch";
import Addons from "../Addons";

const PersonalAssets = ({
  state,
  setState,
  handleExtraChange,
  extraField,
  activeTab,
  handleSaveField,
}) => {
  const handleToggle = (value, name) => {
    setState((pre) => ({ ...pre, [name]: value }));
  };
  return (
    <div>
      <section className="view-data">
        <Row className="main-view-email pt-3">
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Cash on hand:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "cash_on_hand_visible")
                    }
                    checked={state.cash_on_hand_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "cash_on_hand_required")
                    }
                    checked={state.cash_on_hand_required}
                  />
                </div>
              </li>
            </ul>
          </Col>
          <Col md={12}>
            <h5 className="mb-4">Personal Bank Account</h5>
          </Col>
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Full Name:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "personal_fullname_visible")
                    }
                    checked={state.personal_fullname_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "personal_fullname_required")
                    }
                    checked={state.personal_fullname_required}
                  />
                </div>
              </li>
            </ul>
          </Col>
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Bank Address:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "personal_address_of_bank_visible")
                    }
                    checked={state.personal_address_of_bank_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "personal_address_of_bank_required")
                    }
                    checked={state.personal_address_of_bank_required}
                  />
                </div>
              </li>
            </ul>
          </Col>
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Account type:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "personal_account_type_visible")
                    }
                    checked={state.personal_account_type_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "personal_account_type_required")
                    }
                    checked={state.personal_account_type_required}
                  />
                </div>
              </li>
            </ul>
          </Col>
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Account Number:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "personal_account_number_visible")
                    }
                    checked={state.personal_account_number_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "personal_account_number_required")
                    }
                    checked={state.personal_account_number_required}
                  />
                </div>
              </li>
            </ul>
          </Col>
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Account Balance:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "personal_account_balance_visible")
                    }
                    checked={state.personal_account_balance_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "personal_account_balance_required")
                    }
                    checked={state.personal_account_balance_required}
                  />
                </div>
              </li>
            </ul>
          </Col>
          <Col md={12}>
            <h5 className="mb-4">Additional Bank Account</h5>
          </Col>
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Full Name:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "additional_fullname_visible")
                    }
                    checked={state.additional_fullname_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "additional_fullname_required")
                    }
                    checked={state.additional_fullname_required}
                  />
                </div>
              </li>
            </ul>
          </Col>
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Bank Address:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "additional_address_of_bank_visible")
                    }
                    checked={state.additional_address_of_bank_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "additional_address_of_bank_required")
                    }
                    checked={state.additional_address_of_bank_required}
                  />
                </div>
              </li>
            </ul>
          </Col>
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Account type:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "additional_account_type_visible")
                    }
                    checked={state.additional_account_type_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "additional_account_type_required")
                    }
                    checked={state.additional_account_type_required}
                  />
                </div>
              </li>
            </ul>
          </Col>
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Account Number:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "additional_account_number_visible")
                    }
                    checked={state.additional_account_number_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "additional_account_number_required")
                    }
                    checked={state.additional_account_number_required}
                  />
                </div>
              </li>
            </ul>
          </Col>
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Account Balance:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "additional_account_balance_visible")
                    }
                    checked={state.additional_account_balance_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "additional_account_balance_required")
                    }
                    checked={state.additional_account_balance_required}
                  />
                </div>
              </li>
            </ul>
          </Col>
          <Col md={12}>
            <h5 className="mb-4">Investment</h5>
          </Col>
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Investment type:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "investment_type_visible")
                    }
                    checked={state.investment_type_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "investment_type_required")
                    }
                    checked={state.investment_type_required}
                  />
                </div>
              </li>
            </ul>
          </Col>
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Full Name:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "investment_fullname_visible")
                    }
                    checked={state.investment_fullname_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "investment_fullname_required")
                    }
                    checked={state.investment_fullname_required}
                  />
                </div>
              </li>
            </ul>
          </Col>
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Address of Institution:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(
                        event,
                        "investment_address_of_institution_visible"
                      )
                    }
                    checked={state.investment_address_of_institution_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(
                        event,
                        "investment_address_of_institution_required"
                      )
                    }
                    checked={state.investment_address_of_institution_required}
                  />
                </div>
              </li>
            </ul>
          </Col>

          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Account Number:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "investment_account_number_visible")
                    }
                    checked={state.investment_account_number_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "investment_account_number_required")
                    }
                    checked={state.investment_account_number_required}
                  />
                </div>
              </li>
            </ul>
          </Col>
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Account Balance:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "investment_account_balance_visible")
                    }
                    checked={state.investment_account_balance_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "investment_account_balance_required")
                    }
                    checked={state.investment_account_balance_required}
                  />
                </div>
              </li>
            </ul>
          </Col>
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Whole life insurance:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "whole_life_insurance_visible")
                    }
                    checked={state.whole_life_insurance_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "whole_life_insurance_required")
                    }
                    checked={state.whole_life_insurance_required}
                  />
                </div>
              </li>
            </ul>
          </Col>
          <Col md={12}>
            <h5 className="mb-4">Credit Account</h5>
          </Col>
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Full Name:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "credit_fullname_visible")
                    }
                    checked={state.credit_fullname_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "credit_fullname_required")
                    }
                    checked={state.credit_fullname_required}
                  />
                </div>
              </li>
            </ul>
          </Col>
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Bank Address:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "credit_address_of_bank_visible")
                    }
                    checked={state.credit_address_of_bank_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "credit_address_of_bank_required")
                    }
                    checked={state.credit_address_of_bank_required}
                  />
                </div>
              </li>
            </ul>
          </Col>
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Account type:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "credit_account_type_visible")
                    }
                    checked={state.credit_account_type_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "credit_account_type_required")
                    }
                    checked={state.credit_account_type_required}
                  />
                </div>
              </li>
            </ul>
          </Col>
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Account number:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "credit_account_number_visible")
                    }
                    checked={state.credit_account_number_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "credit_account_number_required")
                    }
                    checked={state.credit_account_number_required}
                  />
                </div>
              </li>
            </ul>
          </Col>
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Account Balance:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "credit_account_balance_visible")
                    }
                    checked={state.credit_account_balance_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "credit_account_balance_required")
                    }
                    checked={state.credit_account_balance_required}
                  />
                </div>
              </li>
            </ul>
          </Col>

          {extraField &&
            extraField.length > 0 &&
            extraField.map((item, idx) => {
              return (
                <Col md={6} className="left-name-data my-2" key={idx}>
                  <h6>
                    <strong className="text-capitalize">{item.title}:</strong>
                  </h6>
                  <ul className="list-unstyled ps-0 mb-0">
                    <li className="d-flex align-items-center  gap-10">
                      <div className="left d-flex align-items-center gap-10">
                        <strong className="pe-2">Visible</strong>
                        <Switch
                          offColor="#888"
                          onColor="#3363df"
                          onChange={(event) =>
                            handleToggle(
                              event,
                              item.title.toLowerCase().split(" ").join("_") +
                                "_visible"
                            )
                          }
                          checked={
                            state[
                              item.title.toLowerCase().split(" ").join("_") +
                                "_visible"
                            ]
                          }
                        />
                      </div>
                      <div className="right d-flex align-items-center gap-10">
                        <strong className="pe-2">Required</strong>
                        <Switch
                          offColor="#888"
                          onColor="#3363df"
                          onChange={(event) =>
                            handleToggle(
                              event,
                              item.title.toLowerCase().split(" ").join("_") +
                                "_required"
                            )
                          }
                          checked={
                            state[
                              item.title.toLowerCase().split(" ").join("_") +
                                "_required"
                            ]
                          }
                        />
                      </div>
                    </li>
                  </ul>
                </Col>
              );
            })}
        </Row>
      </section>
      <div className="heading-fields-type">
        <h2>Add More Fields in Finance form.</h2>
        <Addons
          handleChange={handleExtraChange}
          data={extraField}
          activeTab={activeTab}
          handleSaveField={handleSaveField}
        />
      </div>
    </div>
  );
};

export default PersonalAssets;
